var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuickBuy = function SvgQuickBuy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11.36h-19v7.533a3.045 3.045 0 0 0 3.045 3.046H21.5v-3.79h-3.076v-3H21.5zM10.123 9.317h3.894a5.774 5.774 0 0 0-11.517 0h3.894L8.26 7.452z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.565,
    cy: 5.878,
    r: 2.878
  })));
};
export default SvgQuickBuy;